import { DisplayListItemView } from "./DisplayListItemView";

export const DisplayListView = Marionette.CollectionView.extend({
    childView: DisplayListItemView
});


// WEBPACK FOOTER //
// ./src/js/view/components/DisplayListView.js